<template>
    <div class="reg-body">
        <!--登录注册顶部-->
        <backindex></backindex>
        <div class="reg-title">{{$t("regPage")}}</div>
        <div class="reg-area">
            <div class="reg-name">
                <div class="name-font">{{$t("memAccount")}}</div>
                <div class="reg-input">
                    <input type="text" v-model="email" :placeholder="tips">
                </div>
            </div>
            <div class="reg-sex">
                <div class="sex-font">{{$t("gender")}}</div>
                <div class="sex-area">
                    <div class="sex-select">
                        <div :class="{'has-select':sexFlag==1,'sex-man':true}" @click="selectMan" :sex="123">{{$t("male")}}</div>
                        <div :class="{'has-select':sexFlag==0,'sex-man':true}" @click="selectWoman">{{$t("female")}}</div>
                    </div>
                </div>
            </div>
            <div class="reg-pass">
                <div class="pass-font">{{$t("memPwd")}}</div>
                <div class="reg-input">
                    <input type="password" v-model="password" :placeholder="tips2">
                </div>
            </div>
            <div class="reg-pass">
                <div class="pass-font">{{$t("confirmPwd")}}</div>
                <div class="reg-input">
                    <input type="password" v-model="passagain" :placeholder="tips3">
                </div>
            </div>
            <div class="reg-lang">
                <div class="lang-font">{{$t("langSetting")}}</div>
                <div class="lang-area">
                    <div class="lang-select">
                        <div :class="{'has-select':langFlag==1,'sex-man':true}" @click="selectJian">简体</div>
                        <div :class="{'has-select':langFlag==0,'sex-man':true}" @click="selectFan">繁体</div>
                    </div>
                </div>
            </div>
        </div>
        <!--按钮区域-->
        <div class="reg-btn" @click="register">{{$t("regNow")}}</div>
        <!--底部组件-->
        <div class="reg-bottom">
            <pagebottom></pagebottom>
        </div>
    </div>
</template>

<script>
    import backindex from "@/components/common/backindex"
    import pagebottom from "@/components/common/pagebottom"
    export default {
        name: "register",
        components:{
            pagebottom,
            backindex
        },
        data(){
            return{
                //注册信息
                tips:"电子邮箱/手机号码/昵称",
                tips2:"请输入密码",
                tips3:"再次输入密码",
                email:"",
                password:"",
                passagain:"",
                sex:-1,
                lang:-1,
                //选择按钮 样式开关
                sexFlag:-1,
                langFlag:-1,
            }
        },
        mounted:function(){
            this.tips = this.$t("inputAccount");
            this.tips2= this.$t("inputPwd");
            this.tips3= this.$t("inputPwd2");
        },
        methods:{
            //选择性别
            selectMan(e){
                console.log(e);
                if(this.sexFlag==1) return;
                this.sexFlag  = 1;
                this.sex = 1;
            },
            selectWoman(){
                if(this.sexFlag==0) return;
                this.sexFlag  = 0;
                this.sex = 0;
            },
            //选择简体繁体
            selectJian(){
                if(this.langFlag==1) return;
                this.langFlag  = 1;
                this.lang = 1;
            },
            selectFan(){
                if(this.langFlag==0) return;
                this.langFlag  = 0;
                this.lang = 0;
            },
            register(){
                if(this.sex==-1){
                    this.$toast({
                        message: this.$t("chooseSex"),
                        duration: 3000
                    });
                    return;
                }
                if(this.lang==-1){
                    this.$toast({
                        message: this.$t("chooseLang"),
                        duration: 3000
                    });
                    return;
                }
                //检查密码
                if(this.password!=this.passagain){
                     this.$toast({
                        message: this.$t("pwdNotMatch"),
                        duration: 3000
                    });
                    return;
                }
                var lang = this.lang==1?"zh-cn":"zh-tw";
                this.req.register(this.email,this.password,this.sex,lang).then(res=>{
                    localStorage.setItem("loginUserID",res.data.id);
                    //如果有回跳，跳转至回跳
                    var url = JSON.parse(localStorage.getItem("loginBack"));
                    if(url){
                        localStorage.removeItem("loginBack");
                        this.$router.push(url);
                    }else{
                        this.go.goPersonal();
                    }
                })
            }
        }
    }

</script>

<style scoped>
    .reg-body{
        width: 100%;
        height: 100%;
    }
    .reg-bottom{
        width: 100%;
        height: auto;
        margin-top: 0.7em;
        bottom: 0;
        left: 0;
    }
    .reg-title{
        width:100%;
        height: 1.33rem;
        background: #ffffff;
        border-bottom: 0.02rem solid #e6e6e6;
        font-size: 0.34rem;
        color: #ff1f4f;
        text-align: center;
        line-height: 1.33rem;
        font-weight: 700;
    }
    .reg-area{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding-left: 0.4rem;
        padding-bottom: 0.5rem;
    }
    .reg-name,.reg-pass{
        width: 100%;
        padding: 0.5rem 0 0 0;
        display: flex;
        justify-content: space-between;
    }
    .name-font,.pass-font,.sex-font,.lang-font{
        font-size: 0.3rem;
        font-weight: 700;
    }
    .reg-input{
        width: 5.25rem;
        border-bottom: 0.02rem solid #e6e6e6;
        padding: 0.06rem 0 0.5rem;
    }
    .reg-input input{
        font-size: 0.26rem;
        line-height: 0.32rem;
        border: none;
        outline: none;
        display: block;
        width: 100%;
        box-sizing: border-box;
        padding-left: 0.2rem;
    }
    input::placeholder{
        color: #666666;
    }
    .reg-sex,.reg-lang{
        width: 100%;
        padding: 0.34rem 0 0 0;
        display: flex;
        justify-content: space-between;
    }
    .sex-font,.lang-font{
        padding-top: 0.16rem;
    }
    .sex-area,.lang-area{
        width: 5.25rem;
        border-bottom: 0.02rem solid #e6e6e6;
        padding: 0 0 0.34rem 0.2rem;
        box-sizing: border-box;
    }
    .sex-select,.lang-select{
        width: 2rem;
        height: 0.62rem;
        box-sizing: border-box;
        border: 0.02rem solid #fd711e;
        border-radius: 0.08rem;
        display: flex;
        justify-content: space-between;
    }
    .sex-man{
        width: 0.98rem;
        height: 0.58rem;
        text-align: center;
        font-size: 0.24rem;
        line-height: 0.58rem;
        color: #666666;
    }
    .has-select{
        background: #fd711e;
        color: #ffffff;
    }
    .reg-btn{
        width: 5.8rem;
        height: 0.84rem;
        box-sizing: border-box;
        margin: 0 auto;
        font-size: 0.3rem;
        line-height: 0.84rem;
        text-align: center;
        border-radius: 0.08rem;
        background: #ff1f4f;
        color: #ffffff;
    }
</style>


// WEBPACK FOOTER //
// src/components/register.vue